<template>
  <div class="goodurlcontaione">
    <md-field>
      <md-textarea-item
        ref="demo2"
        class="demo2"
        :autosize="true"
        v-model="url"
        placeholder="在此粘貼商品鏈接"
      >
      </md-textarea-item>
      <div style="width: 100%;display: flex;align-items: center;justify-content: space-between;height: 1rem">
        <md-button type="link" style="color: red" @click="gourl">在哪能找到商品鏈接？</md-button>
        <md-button type="primary" size="small" inline @click="geturl">確定</md-button>
      </div>

    </md-field>
  </div>
</template>

<script>
import eventBus from '../../until/eventBus'
import {TextareaItem, Field,Button,Toast} from 'mand-mobile'
export default {
  name: "goodUrl",
  components: {
    [TextareaItem.name]: TextareaItem,
    [Field.name]: Field,
    [Button.name]: Button,
  },
  data() {
    return {
      url: '',
    }
  },
  activated() {
    this.url=this.$route.query.url
  },
  mounted() {
    console.log(this.$route.query)
  },
  methods:{
    gourl(){
      window.location.href = JSON.parse(localStorage.getItem('appUrl')).parcelCourseImageUrl
    },
    geturl(){
      if(this.url){
        eventBus.$emit('goodeUrlinfo', this.url, this.$route.query.index)
        this.$router.go(-1)
      }else{
        Toast.failed('請在此粘貼商品鏈接')
      }
    }
  }
}
</script>

<style lang="less">
.goodurlcontaione{
  .md-field{
    padding: 0 0.4rem;
  }
}
</style>
